import { TeamMember } from "../../../../features/Booking-Form/typings/team-member";
import * as _ from "lodash";

export function generatePrestoredColleagues({
  user,
  sub,
  scheduleColleaguesData,
  storedScheduleColleaguesData
}: {
  user: { userBookedById: string; firstName: string; surname: string; userId: string };
  sub: string;
  scheduleColleaguesData: TeamMember[];
  storedScheduleColleaguesData: string[];
}) {
  const currUser = scheduleColleaguesData.find(col => col.userId === sub) ?? user;

  // initially select the schedule colleagues from data with storedUsers value
  const preStoredColleagues = scheduleColleaguesData.filter(col =>
    storedScheduleColleaguesData.includes(col.userId)
  );

  const preStored = _.uniqBy([...preStoredColleagues, currUser], user => user.userId);
  return preStored;
}
